
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoParaGrid extends Serenity.EntityGrid<PoParaRow, any> {
        protected getColumnsKey() { return PoParaColumns.columnsKey; }
        protected getDialogType() { return PoParaDialog; }
        protected getIdProperty() { return PoParaRow.idProperty; }
        protected getInsertPermission() { return PoParaRow.insertPermission; }
        protected getLocalTextPrefix() { return PoParaRow.localTextPrefix; }
        protected getService() { return PoParaService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}